<template>
  <b-modal
      v-model="model"
      @update:model-value="onClose"
      size="2xl"
      :title="$t('experience.delete_title')"
      :description="$t('experience.delete_confirmation')"
  >
    <template #footer>
      <div class="flex items-center px-10 pb-10 pt-2 gap-4">
        <b-button light @click="onClose" block>{{ $t('common.cancel') }}</b-button>
        <b-button @click="onDeleteClick" block variant="destructive" light :loading="isDeleting" :disabled="isDeleting">{{ $t('common.delete') }}</b-button>
      </div>
    </template>
  </b-modal>
</template>

<script setup lang="ts">
import BModal from "~/components/modal/BModal.vue";
import BButton from "~/components/forms/BButton.vue";

const route = useRoute();
const router = useRouter();
const { t } = useI18n();
const model = defineModel({ default: false });
const emit = defineEmits(['update:modelValue', 'input']);
const experienceStore = useExperienceStore()
const alerts = useAlerts();
const isDeleting = ref(false);

watch(() => route.query, (newValue) => {
  if (newValue.action === 'delete' && newValue.resource === 'experience' && newValue.resource_id) {
    model.value = true
  }
}, { immediate: true });

const onClose = () => {
  model.value = false
  emit('input', false)
}

watch(() => model.value, (newValue) => {
  if (!newValue) {
    const query = { ...route.query };
    delete query.action;
    delete query.resource;
    delete query.resource_id;
    router.replace({ path: route.path, query });
  }
}, { immediate: true });

const onDeleteClick = async () => {
  if (!('resource_id' in route.query)) return;

  isDeleting.value = true;
  try {
    await experienceStore.deleteExperience(route.query.resource_id as string);
    onClose();
  } catch {
    alerts.add({
      type: 'danger',
      title: t('experience.delete_error'),
    });
  } finally {
    isDeleting.value = false;
  }
}
</script>
